import type { StaffApp, WorkItem, WorkView } from '@ps/contracts/work';
import { api } from './http';

export type { StaffApp, WorkItem, WorkView };

/** "Waiting for you": the signed-in staff member's work, by role (Admin or Console session). */
export const workApi = (app: StaffApp) => ({ get: () => api<WorkView>('GET', `/${app}/work`) });
